import { useId } from 'react';
import Filters from 'src/components/form/filters/filters';
import LocationsInput from 'src/components/form/search-select-input/locations-input';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import { VETERAN_LOCATIONS } from 'src/constants/routes';
import { ONLINE } from 'src/constants/locations';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import css from './services-page.module.scss';
import { FilterProps } from 'src/types';

export default function ServicesFilters({ pageName, onSearch, initialFilters }: Readonly<FilterProps>) {
  const locationId = useId();
  const inputId = useId();

  return (
    <Filters
      initialFilters={initialFilters}
      onSearch={onSearch}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search', 'locationId']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.filtersGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати послугу'
            error={errors?.text?.message}
            inputProps={registerAndClearOnChange('search')}
          />
          {VETERAN_LOCATIONS.title === pageName && (
            <LocationsInput id={locationId} name='locationId' defaultLocation={ONLINE} placeholder='Всі локації' />
          )}
        </div>
      )}
    />
  );
}
